var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"ma-5",attrs:{"color":"transparent"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.siteProfile.comment_primary)}})])}
var staticRenderFns = []

export { render, staticRenderFns }